import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function CookiePolicy() {
  const { language } = useLanguage();

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="cookie-policy-page">
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-[#1B3A7B] hover:underline mb-6">
        <ChevronLeft className="w-4 h-4" />
        {language === 'pl' ? 'Powrot do kalkulatora' : 'Back to calculator'}
      </Link>

      <h1 className="text-3xl sm:text-4xl font-heading font-bold text-[#1B3A7B] mb-8">
        {language === 'pl' ? 'Polityka Cookies' : 'Cookie Policy'}
      </h1>

      <div className="prose prose-slate max-w-none space-y-6 text-sm leading-relaxed text-slate-700">
        <p className="text-slate-500 text-xs">Data ostatniej aktualizacji: 15 lutego 2026 r.</p>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">1. Czym sa pliki cookies?</h2>
          <p>Pliki cookies (ciasteczka) to male pliki tekstowe zapisywane na urzadzeniu Uzytkownika podczas korzystania z serwisu internetowego. Sluza one do prawidlowego funkcjonowania serwisu oraz zapamietywania preferencji Uzytkownika.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">2. Administrator</h2>
          <p>Administratorem serwisu wykorzystujacego pliki cookies jest <strong>Biuro Rachunkowe Kurdynowski</strong>.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">3. Rodzaje wykorzystywanych cookies</h2>
          <p>W Serwisie wykorzystywane sa nastepujace rodzaje plikow cookies:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Cookies niezbedne (sesyjne)</strong> &mdash; wymagane do prawidlowego dzialania Serwisu, w tym zapamietania wyborow dokonanych w kalkulatorze. Usuwane po zakonczeniu sesji przegladarki.</li>
            <li><strong>Cookies funkcjonalne</strong> &mdash; zapamietuja preferencje Uzytkownika, np. wybrany jezyk (PL/EN). Przechowywane przez okres 30 dni.</li>
            <li><strong>Cookies uwierzytelniajace</strong> &mdash; sluza do utrzymania sesji logowania administratora. Przechowywane przez 24 godziny.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">4. Cele wykorzystywania cookies</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Zapewnienie prawidlowego dzialania kalkulatora wyceny</li>
            <li>Zapamietywanie preferencji jezykowych</li>
            <li>Uwierzytelnianie sesji administracyjnej</li>
            <li>Przechowywanie danych formularza w trakcie korzystania z kalkulatora</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">5. Zarzadzanie plikami cookies</h2>
          <p>Uzytkownik moze samodzielnie zarzadzac plikami cookies poprzez ustawienia swojej przegladarki internetowej. Mozliwe opcje:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Akceptowanie wszystkich cookies</li>
            <li>Blokowanie wszystkich cookies</li>
            <li>Selektywne blokowanie wybranych cookies</li>
            <li>Usuwanie zapisanych cookies</li>
          </ul>
          <p className="mt-3">Wylaczenie cookies moze spowodowac nieprawidlowe dzialanie niektorych funkcji Serwisu, w szczegolnosci kalkulatora wyceny i przelacznika jezykow.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">6. Cookies podmiotow trzecich</h2>
          <p>Serwis nie wykorzystuje cookies podmiotow trzecich w celach reklamowych lub analitycznych.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">7. Podstawa prawna</h2>
          <p>Korzystanie z plikow cookies odbywa sie na podstawie art. 173 ustawy z dnia 16 lipca 2004 r. Prawo telekomunikacyjne oraz art. 6 ust. 1 lit. f RODO (prawnie uzasadniony interes administratora).</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">8. Kontakt</h2>
          <p>Pytania dotyczace polityki cookies mozna kierowac na adres: <a href="mailto:monika.gawkowska@kurdynowski.pl" className="text-[#1B3A7B] hover:underline">monika.gawkowska@kurdynowski.pl</a></p>
        </section>
      </div>
    </div>
  );
}
